// Exporta dados pra CSV compatível com Excel pt-BR (separador ; + BOM UTF-8).
// Sem dependência externa. Abre direto no Excel com colunas/acentos corretos.
export type ColunaExcel = { header: string; key: string; fmt?: (v: any, row: any) => any }

function esc(v: any): string {
  const s = v == null ? '' : String(v)
  return /[";\n\r]/.test(s) ? '"' + s.replace(/"/g, '""') + '"' : s
}

export function exportarExcel(filename: string, colunas: ColunaExcel[], linhas: any[]): void {
  const SEP = ';'
  const head = colunas.map(c => esc(c.header)).join(SEP)
  const body = linhas.map(r => colunas.map(c => esc(c.fmt ? c.fmt(r[c.key], r) : r[c.key])).join(SEP)).join('\r\n')
  const csv = '﻿' + head + '\r\n' + body
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename.endsWith('.csv') ? filename : filename + '.csv'
  document.body.appendChild(a)
  a.click()
  a.remove()
  URL.revokeObjectURL(url)
}

// número pt-BR (vírgula decimal) pra Excel ler como número
export const numBR = (v: any) => (v == null || v === '' ? '' : Number(v).toFixed(2).replace('.', ','))
